import { ofType } from "redux-observable";
import { ignoreElements, tap } from "rxjs/operators";
import { utilTracking } from "../../../utils/tracking/utilTracking";
import { TypeActionGameTracking } from "../actionGameTracking";
export var epicUpdateTracking = function (action$, state$) {
    return action$.pipe(ofType(TypeActionGameTracking.UpdateTracking), tap(function (action) {
        var data = action.getData(state$.value);
        var trackingName = action.trackingName, logMessage = action.logMessage;
        return utilTracking.postTrackingData(data, trackingName, logMessage);
    }), ignoreElements());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/epics/epicUpdateTracking.ts
// module id = 1861
// module chunks = 3